module.exports = __webpack_public_path__ + "img/interencheres-2024.3c1e6e53.jpg";